import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FrameModel } from 'src/app/core/interfaces/movie.model';
import * as Masonry from 'masonry-layout';
import * as ImagesLoaded from 'imagesloaded'

@Component({
  selector: 'app-movie-frames-gallery',
  templateUrl: './movie-frames-gallery.component.html',
  styleUrls: ['./movie-frames-gallery.component.scss']
})
export class MovieFramesGalleryComponent implements OnInit, AfterViewInit {
  @ViewChild('imagegrid', { static: true }) imageContainer!: ElementRef;

  @Input() Frames: FrameModel[];
  modalFrames: any;
  currentIndex: number = 0;
  loadingImages = true;
  noFrames = false;

  constructor() { }

  ngOnInit(): void {
    this.modalFrames = $('#modalFrames');
    if (this.Frames.length == 0) {
      this.noFrames = true;
    }
  }

  ngAfterViewInit(): void {

    ImagesLoaded(this.imageContainer.nativeElement, () => {
      var elem = document.querySelector('.grid');
      var msnry = new Masonry(elem, {
        itemSelector: '.grid-item',
        // columnWidth: '.grid-sizer',
        percentPosition: true
      });
      this.loadingImages = false;

    });

  }

  openModal(index: number) {
    this.currentIndex = index;
    this.modalFrames.modal('show');
  }

  closeModal() {
    this.modalFrames.modal('hide');
  }

  ngOnDestroy(): void {
    if (this.modalFrames) this.modalFrames.modal('hide');
  }

  prevImage(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.Frames.length - 1; // Loop back to the last image
    }
  }

  nextImage(): void {
    if (this.currentIndex < this.Frames.length - 1) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0; // Loop back to the first image
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (this.modalFrames) {
      if (event.key === 'ArrowLeft') {
        this.prevImage();
      } else if (event.key === 'ArrowRight') {
        this.nextImage();
      }
    }
  }

}

